import {
  CountryItem as CXCountryItem,
  CountryField as CXCountryField,
  ICountryItem as CXICountryItem,
  ICountryField as CXICountryField
} from '@sanlamcx/react-ui-next-country-code';

export type ICountryField = CXICountryField;
export type ICountryItem = CXICountryItem;

type CountryField = typeof CXCountryField;
type CountryItem = typeof CXCountryItem;

export const CountryField: CountryField = CXCountryField;
export const CountryItem: CountryItem = CXCountryItem;
